import { useCallback } from "react";
import {
  FEATURE_ADDON_KEYS,
  isAddonUsageAtLimit,
  isFeatureAddonLimitError,
} from "../actions/featureAddons";
import useFeatureAddonPaywall from "./useFeatureAddonPaywall";

/**
 * Automations addon gates: saved-automation capacity, platforms, and frequencies.
 */
const useAutomationsAddon = () => {
  const paywall = useFeatureAddonPaywall({
    addonKey: FEATURE_ADDON_KEYS.AUTOMATIONS,
  });

  const blockIfCapacityReached = useCallback(
    ({ liveCount }) =>
      paywall.blockWhen((status) => isAddonUsageAtLimit(status, liveCount)),
    [paywall.blockWhen]
  );

  const openPaywallFromLimitError = useCallback(
    (response) => {
      if (!paywall.eligible || !isFeatureAddonLimitError(response))
        return false;
      paywall.openPaywall();
      return true;
    },
    [paywall.eligible, paywall.openPaywall]
  );

  const allowedPlatforms = paywall.eligible
    ? (paywall.status?.effective?.platforms ?? null)
    : null;
  const allowedFrequencies = paywall.eligible
    ? (paywall.status?.effective?.frequencies ?? null)
    : null;

  return {
    ...paywall,
    blockIfCapacityReached,
    openPaywallFromLimitError,
    allowedPlatforms,
    allowedFrequencies,
  };
};

export default useAutomationsAddon;
